export class PagoErroneo {
    _id_pago_erroneo: Number;
    rut: String;
    nombre: String;
    telefono: String;
    email: String;
    numero_cliente: String;
    direccion: String;
    id_comuna: String;
    id_region: String;
    numero_cliente_error: String;
    direccion_error: String;
    id_comuna_error: String;
    medio_pago_error: String;
    direccion_sucursal_error: String;
    fecha_pago: Date;
    monto_cancelado: Number;
    archivo_rut_solicitante: String;
    archivo_rut_solicitante_reverso: String;
    archivo_cartola_voucher: String;
    acepto_condiciones: Boolean;
    acepto_newsletters: Boolean;
    acepto_privacidad: Boolean;
    acepto_suscripcion: Boolean;
    token: String;
    ip: String;
 }